import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
    fbq: any;
    _fbq: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private initialized = false;

  init(): void {
    if (this.initialized) return;
    this.initialized = true;

    if (environment.gaMeasurementId) {
      this.loadGoogleTag(environment.gaMeasurementId);
    }
    if (environment.metaPixelId) {
      this.loadMetaPixel(environment.metaPixelId);
    }
  }

  // Google tag (gtag.js)
  private loadGoogleTag(measurementId: string): void {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      // gtag.js espera el objeto `arguments`, no un array
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', measurementId);
  }

  // Meta Pixel Code
  private loadMetaPixel(pixelId: string): void {
    if (window.fbq) return;

    const fbq: any = function () {
      // eslint-disable-next-line prefer-rest-params
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);

    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
  }
}
